var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { getHeaders } from "../utils/apiUtils";
import { fetchAllPages } from "../utils/fetchAllPages";
export var escapeCql = function (value) { return value.replace(/"/g, '\\"'); };
export function fetchAgencyPrefixes(ky_1) {
    return __awaiter(this, arguments, void 0, function (ky, params) {
        var _a, agencies, query, _b, offset, _c, limit, sortBy, queryParts, searchParams, baseQuery, response;
        if (params === void 0) { params = {}; }
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    _a = params.agencies, agencies = _a === void 0 ? [] : _a, query = params.query, _b = params.offset, offset = _b === void 0 ? 0 : _b, _c = params.limit, limit = _c === void 0 ? 20 : _c, sortBy = params.sortBy;
                    queryParts = [];
                    if (query) {
                        queryParts.push(query);
                    }
                    if (agencies.length > 0) {
                        queryParts.push("(".concat(agencies.map(function (a) { return "internationalPrefix.agency==\"".concat(escapeCql(a), "\""); }).join(" or "), ")"));
                    }
                    searchParams = new URLSearchParams();
                    baseQuery = queryParts.length > 0 ? queryParts.join(" and ") : "cql.allRecords=1";
                    searchParams.set("query", sortBy ? "".concat(baseQuery, " sortBy ").concat(sortBy) : baseQuery);
                    searchParams.set("offset", String(offset));
                    searchParams.set("limit", String(limit));
                    return [4 /*yield*/, ky.get("agency-prefixes", {
                            searchParams: searchParams,
                            headers: getHeaders(),
                        })];
                case 1:
                    response = _d.sent();
                    if (!response.ok) {
                        throw new Error("Fetch error: ".concat(response.status, " ").concat(response.statusText));
                    }
                    return [2 /*return*/, response.json()];
            }
        });
    });
}
/**
 * Loads every agency prefix matching the filters (a small code list for
 * selects), page by page within the backend list limit.
 */
export var fetchAllAgencyPrefixes = function (ky_1) {
    var args_1 = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        args_1[_i - 1] = arguments[_i];
    }
    return __awaiter(void 0, __spreadArray([ky_1], args_1, true), void 0, function (ky, params) {
        var items;
        if (params === void 0) { params = {}; }
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, fetchAllPages(function (offset, limit) {
                        return fetchAgencyPrefixes(ky, __assign(__assign({}, params), { offset: offset, limit: limit, sortBy: "value id" }));
                    })];
                case 1:
                    items = _a.sent();
                    return [2 /*return*/, { items: items, totalRecords: items.length }];
            }
        });
    });
};
export var fetchAgencyPrefixById = function (ky, id) { return __awaiter(void 0, void 0, void 0, function () {
    var response;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, ky.get("agency-prefixes/".concat(encodeURIComponent(id)), {
                    headers: getHeaders(),
                })];
            case 1:
                response = _a.sent();
                if (!response.ok) {
                    throw new Error("Fetch error: ".concat(response.status, " ").concat(response.statusText));
                }
                return [2 /*return*/, response.json()];
        }
    });
}); };
export var createAgencyPrefix = function (ky, agencyPrefix) { return __awaiter(void 0, void 0, void 0, function () {
    var response;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, ky.post("agency-prefixes", {
                    json: agencyPrefix,
                    headers: getHeaders(),
                })];
            case 1:
                response = _a.sent();
                if (!response.ok) {
                    throw new Error("Create error: ".concat(response.status, " ").concat(response.statusText));
                }
                return [2 /*return*/, response.json()];
        }
    });
}); };
export var updateAgencyPrefix = function (ky, id, updates) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, ky.put("agency-prefixes/".concat(encodeURIComponent(id)), {
                    json: updates,
                    headers: getHeaders(),
                })];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}); };
export var fetchValidMagnitudes = function (ky, id) { return __awaiter(void 0, void 0, void 0, function () {
    var response;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, ky.get("agency-prefixes/".concat(encodeURIComponent(id), "/valid-magnitudes"), { headers: getHeaders() })];
            case 1:
                response = _a.sent();
                if (!response.ok) {
                    throw new Error("Fetch error: ".concat(response.status, " ").concat(response.statusText));
                }
                return [2 /*return*/, response.json()];
        }
    });
}); };
export var deleteAgencyPrefix = function (ky, id) { return __awaiter(void 0, void 0, void 0, function () {
    var response;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, ky.delete("agency-prefixes/".concat(encodeURIComponent(id)), { headers: getHeaders() })];
            case 1:
                response = _a.sent();
                if (!response.ok) {
                    throw new Error("Delete error: ".concat(response.status, " ").concat(response.statusText));
                }
                return [2 /*return*/];
        }
    });
}); };
